import axios, { AxiosRequestConfig } from "axios";
import appConfig from "configs/app.config";
import deepParseJson from "utils/deepParseJson";

const unauthorizedCode = [401];
const PERSIST_STORE_NAME = "admin";
const MERCHANT_STORAGE_KEY = "merchant";
const authToken =
  "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIyLEphbWVzLG51bGwsQm9uZCxudWxsLGJvbmRAZ21haWwuY29tLEJFTkJST09LQkJRMTMwMTI4IiwiaXNzIjoiQmFzaWwtUG9zIiwiaWF0IjoxNzAyOTExMTE3LCJleHAiOjE3MDI5OTc1MTd9.wn64NgryGQ8aqm7gVLjjQdGoJrOw2P0Aj2CLPZYIWiTZXWSz_FveU2TFguRL-VVhVO0Piegc1IN5eHZDs-ayhg";

const BaseService = axios.create({
  timeout: 60000,
  baseURL: appConfig.apiPrefix,
});
const saveMerchantToLocalStorage = (merchant: any) => {
  localStorage.setItem(MERCHANT_STORAGE_KEY, merchant);
};

const extractMerchantFromURL = () => {
  const pathArray = window.location.pathname.split("/");
  return pathArray[1] || null;
};

const getHeaders = (): AxiosRequestConfig["headers"] => {
  const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME);
  const persistData = deepParseJson(rawPersistData);

  const timeZone = "America/Chicago";
  const merchant = localStorage.getItem(MERCHANT_STORAGE_KEY);

  const headers: AxiosRequestConfig["headers"] = {
    // MID: merchant,
    MID: "BENBROOKBBQ130128",
    "Content-Type": "application/json",
    TimeZone: timeZone,
    Accept: "*/*",
    "Cache-Control": "no-cache",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,POST,OPTIONS,DELETE,PUT",
    Authorization: `Bearer ${authToken}`, // Add the Authorization header with the token
  };

  // Check if authToken is defined before adding Authorization header
  // if (authToken) {
  //   headers.Authorization = `Bearer ${authToken}`;
  // }

  return headers;
};

BaseService.interceptors.request.use(
  (config: any) => {
    const headers: AxiosRequestConfig["headers"] = getHeaders();
    // Assign the headers to the config object
    config.headers = headers;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default BaseService;
